import * as helpers from './helpers'

const defaultListReducerForAdAudits = helpers.createListReducer({listViewName: 'ad_audit_list'})
export const ad_audits = (state = helpers.listGetInitialState(), {type, payload, reqId}) => {
    //overwrite or add custom actions catches here
    return defaultListReducerForAdAudits({state, type, payload, reqId})
}
